(function () {
  const MODAL_SELECTOR = '.image-with-text-video-modal';
  const TRIGGER_SELECTOR = '.image-with-text__video-trigger';
  const MOBILE_MEDIA_QUERY = window.matchMedia('(max-width: 767px)');

  const getActiveVideoElement = (modal) => {
    const breakpoint = MOBILE_MEDIA_QUERY.matches ? 'mobile' : 'desktop';

    return (
      modal.querySelector(`[data-modal-video="${breakpoint}"] video-element`) ||
      modal.querySelector('video-element')
    );
  };

  const pauseVideoElement = (videoElement, reset = false) => {
    videoElement.pause();

    const video = videoElement.querySelector('video');
    if (video) {
      video.pause();
      if (reset) {
        video.currentTime = 0;
      }
    }
  };

  const pauseAllModalVideos = (modal, reset = true) => {
    modal.querySelectorAll('video-element').forEach((videoElement) => {
      pauseVideoElement(videoElement, reset);
    });
  };

  const playModalVideo = (modal) => {
    const activeVideoElement = getActiveVideoElement(modal);
    if (!activeVideoElement) return;

    modal.querySelectorAll('video-element').forEach((videoElement) => {
      if (videoElement !== activeVideoElement) {
        pauseVideoElement(videoElement, true);
      }
    });

    if (activeVideoElement.hasAttribute('playing')) return;

    activeVideoElement.paused = false;
    activeVideoElement.play();

    const fullscreenEnabled = MOBILE_MEDIA_QUERY.matches
      ? modal.dataset.fullscreenDefaultMobile === 'true'
      : modal.dataset.fullscreenDefault === 'true';

    if (!fullscreenEnabled) return;

    const video = activeVideoElement.querySelector('video');
    if (!video) return;

    const enterFullscreen = () => (video.webkitEnterFullscreen || video.requestFullscreen)?.call(video);

    if (video.readyState >= 1) {
      enterFullscreen();
    } else {
      video.addEventListener('loadedmetadata', enterFullscreen, { once: true });
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      const trigger = event.target.closest(TRIGGER_SELECTOR);
      if (!trigger) return;

      const modal = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!modal?.matches(MODAL_SELECTOR)) return;

      queueMicrotask(() => playModalVideo(modal));
    },
    true
  );

  document.addEventListener('modal:handleAfterHide', (event) => {
    const modal = event.target;
    if (!(modal instanceof HTMLElement) || !modal.matches(MODAL_SELECTOR)) return;
    pauseAllModalVideos(modal);
  });
})();
